import React, { useState, useEffect } from 'react'
import HeadingArea from '../../general/HeadingArea'
import { FaCheck } from 'react-icons/fa';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { MdOutlineEdit } from 'react-icons/md';
import { HiViewGrid } from 'react-icons/hi';
import { useNavigate } from 'react-router-dom';


const OnlineExam = ({ setLoading, userData }) => {
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [response2, setResponse2] = useState({ message: '', status: '' });
  const [onlineExamList, setOnlineExamList] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [showView, setShowView] = useState(false);
const [selectedExam, setSelectedExam] = useState('');
const [questions, setQuestions] = useState([]);
const [selectedQuestions, setSelectedQuestions] = useState([]);
const [examReport, setExamReport] = useState([]);
const navigate = useNavigate();


  const [formData, setFormData] = useState({
    exam: '',
    class: '', // will hold { classId, className }
    subject: '',
    date: '',
    endDate: '',
    startTime: '',
    endTime: '',
    minimumPercentage: '',
    instruction: '',
    added_by: userData.user_id
  });

  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.error('Failed to fetch classes');
      }
    } catch (error) {
      console.error('Error fetching classes:', error);
    }
    setLoading(false);
  }

  useEffect(() => {
    fetchClasses();
fetchOnlineExam();
  }, []);

  // Watch for class change to fetch subjects
  useEffect(() => {
    if (formData.class?.classId) {
      fetchAssignSubject(formData.class.classId);
    } else {
      setSubjects([]);
      setFormData(fd => ({ ...fd, subject: '' })); // reset subject
    }
  }, [formData.class]);

  const fetchAssignSubject = async (classId) => {
    if (!classId) return;
    setLoading(true);
    try {
      const res = await fetch(`https://api.kcian.in/fetch-assigned-subject?class_id=${classId}`);
      if (res.ok) {
        const data = await res.json();
        if (data.length > 0) {
          const uniqueSubjectsMap = new Map();
          data.forEach(item => {
            if (!uniqueSubjectsMap.has(item.sub_id)) {
              uniqueSubjectsMap.set(item.sub_id, item);
            }
          });
          const uniqueSubjects = Array.from(uniqueSubjectsMap.values());
          setSubjects(uniqueSubjects);
          setResponse2({ message: 'Subjects Loaded.', status: 'success' });
        } else {
          setSubjects([]);
          setResponse2({ message: 'No subjects assigned to this class.', status: 'error' });
        }
      } else {
        setSubjects([]);
        setResponse2({ message: 'Error fetching subjects.', status: 'error' });
      }
    } catch (error) {
      console.error('Error fetching assigned subjects:', error);
      setSubjects([]);
      setResponse2({ message: 'Error fetching subjects.', status: 'error' });
    } finally {
      setLoading(false);
      setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'class') {
      const selectedClass = classes.find((cls) => cls.id.toString() === value);
      setFormData((fd) => ({
        ...fd,
        class: selectedClass ? { classId: selectedClass.id, className: selectedClass.class_name } : '',
        subject: '' // reset subject on class change
      }));
    } else {
      setFormData((fd) => ({
        ...fd,
        [name]: value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.class || !formData.class.classId) {
          setResponse2({ message: 'Please Select your Class', status: 'error' });
      return;
    }

    const payload = {
      title: formData.exam,
      class_id: formData.class,
      sub_id: formData.subject,
      start_date: formData.date,
      end_date: formData.endDate,
      start_time: formData.startTime,
      end_time: formData.endTime,
      min_percent: formData.minimumPercentage,
      instruction: formData.instruction,
      added_by: userData.user_id,
    };

    setLoading(true);

    try {
      const res = await fetch('https://api.kcian.in/create-online-exam', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (res.ok) {
        const data = await res.json();
        setFormData({
          exam: '',
          class: '',
          subject: '',
          date: '',
          endDate: '',
          startTime: '',
          endTime: '',
          minimumPercentage: '',
          instruction: '',
          added_by: userData.user_id
        });
        fetchOnlineExam();
        setSubjects([]);
        
          setResponse2({ message: 'Online Exam Created.', status: 'success' });
      } else {
          setResponse2({ message: 'Something went wrong.', status: 'error' });
      }
    } catch (error) {
      console.error('Error saving exam:', error);
    //   alert('Error saving exam.');
    } finally {
      setLoading(false);
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
    }
  };



  const fetchOnlineExam = async () => {

  try {
    const res = await fetch(`https://api.kcian.in/get-online-exam`);
    if (res.ok) {
      const data = await res.json();
      console.log(data);
      setOnlineExamList(data);
    } else {
      setOnlineExamList([]);
      setResponse2({ message: 'No Online Exam Found.', status: 'error' });
      console.error('Failed to fetch questions');
    }
  } catch (error) {
    console.error('Error fetching questions:', error);
    setOnlineExamList([]);
  }

  setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  setLoading(false);
};


      const filteredExam = onlineExamList.filter(q => {
  const term = searchTerm.toLowerCase();
  return (
    q.title.toLowerCase().includes(term) ||
    q.sub_name.toLowerCase().includes(term) ||
    q.sub_type.toLowerCase().includes(term) ||
    q.sub_code.toLowerCase().includes(term)
  );
});


const fetchQuestions = async () => {
  if (!selectedExam) return;
  setLoading(true);

const classObj = JSON.parse(selectedExam.class_id);
 const classId = classObj?.classId;

  try {
    const res = await fetch(`https://api.kcian.in/get-quesbank?class_id=${classId}&sub_id=${selectedExam.sub_id}`);
    if (res.ok) {
      const data = await res.json();
      console.log(data);
      setQuestions(data);
    } else {
      setQuestions([]);
      setResponse2({ message: 'No Questions Added.', status: 'error' });
      console.error('Failed to fetch questions');
    }
  } catch (error) {
    console.error('Error fetching questions:', error);
    setQuestions([]);
  }

  setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  setLoading(false);
};


const handleShowView = async (q) => {
  setSelectedExam(q);
  
  try {
    const assignedQues = JSON.parse(q.ques || '[]');
    setSelectedQuestions(assignedQues);
  } catch {
    setSelectedQuestions([]);
  }

  await fetchQuestions();

  setShowView(true);
};


const fetchOnlineReport = async (qId) => {
  try {
    const response = await fetch(`https://api.kcian.in/get-oexam-report?exam_id=${qId}`);
    if (response.ok) {
      const data = await response.json();

      setExamReport(data);
      return data;
    }
  } catch (error) {
    console.error("Error fetching particulars:", error);
  }

  return []; // fallback
};



const handleShowReport = async (q) => {
    const examReport = await fetchOnlineReport(q.id);

  navigate("/admin/online-exam-report", {
    state: {
      exam: q,
      examReport: examReport,
    },
  });
}


const handleCheckboxToggle = (question) => {
  setSelectedQuestions(prev => {
    const exists = prev.some(q => q.id === question.id);
    if (exists) {
      return prev.filter(q => q.id !== question.id);
    } else {
      return [...prev, question];
    }
  });
};


const submitSelectedQuestions = async () => {
  if (!selectedExam || selectedQuestions.length === 0) return;

const payload = {
  exam_id: selectedExam.id,
ques: selectedQuestions.map(q => ({ id: q.id }))
};

setLoading(true);
try {
  const res = await fetch('https://api.kcian.in/add-online-examques', {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload)
  });

    if (res.ok) {
      setResponse2({ message: 'Questions assigned to exam.', status: 'success' });
      setShowView(false);
      setSelectedQuestions([]);
      fetchQuestions();
    } else {
      setResponse2({ message: 'Something went wrong. Try again', status: 'error' });
    }
  } catch (error) {
    console.error('Error assigning questions:', error);
    // setResponse2({ message: 'Error assigning questions.', status: 'error' });
  } finally {
    setLoading(false);
    setTimeout(() => setResponse2({ message: '', status: '' }), 3000);
  }
};


  return (
    <>
    <section className='py-4'>
      <div className='px-4'>
        <HeadingArea message1="Online Exam" message2="Create Exam" />
        <div className='row'>

            <div className='px-3'>
        {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}
</div>


          <div className='col-xl-3 col-lg-4 col-md-5 col-12 my-2'>
            <div className="profile-card">
              <p className="profile-heading">Add Online Exam</p>
              <form className='mt-4' onSubmit={handleSubmit}>
                {/* Exam Title */}
                <div className='profile-input-area mb-4'>
                  <label className='profile-badge'>Exam Title*</label>
                  <input
                    name='exam'
                    className='profile-input'
                    type='text'
                    value={formData.exam}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Class */}
                <div className='profile-input-area mb-4'>
                  <label className='profile-badge'>Class*</label>
                  <select
                    name='class'
                    className='profile-input'
                    value={formData.class?.classId || ''}
                    onChange={handleChange}
                    required
                  >
                    <option value=''>Select Class..</option>
                    {classes.map(cls => (
                      <option key={cls.id} value={cls.id}>{cls.class_name}</option>
                    ))}
                  </select>
                </div>

                {/* Subject */}
                <div className='profile-input-area mb-4'>
                  <label className='profile-badge'>Subject*</label>
                  <select
                    name='subject'
                    className='profile-input'
                    value={formData.subject}
                    onChange={handleChange}
                    required
                    disabled={subjects.length === 0}
                  >
                    <option value=''>Select Subject..</option>
                    {subjects.map(sub => (
                      <option key={sub.sub_id} value={sub.sub_id}>{sub.sub_name}</option>
                    ))}
                  </select>
                </div>

                {/* Date */}
                <div className="profile-input-area mb-4">
                  <label htmlFor="Date" className="profile-badge">Date*</label>
                  <input
                    type="date"
                    id="Date"
                    name="date"
                    className="profile-input"
                    value={formData.date}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* End Date */}
                <div className="profile-input-area mb-4">
                  <label htmlFor="EndDate" className="profile-badge">End Date*</label>
                  <input
                    type="date"
                    id="EndDate"
                    name="endDate"
                    className="profile-input"
                    value={formData.endDate}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Start Time */}
                <div className='profile-input-area mb-4'>
                  <label className='profile-badge'>Start Time*</label>
                  <input
                    name='startTime'
                    className='profile-input'
                    type='time'
                    value={formData.startTime}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* End Time */}
                <div className='profile-input-area mb-4'>
                  <label className='profile-badge'>End Time*</label>
                  <input
                    name='endTime'
                    className='profile-input'
                    type='time'
                    value={formData.endTime}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Minimum Percentage */}
                <div className='profile-input-area mb-4'>
                  <label className='profile-badge'>Minimum Percentage*</label>
                  <input
                    name='minimumPercentage'
                    className='profile-input'
                    type='text'
                    value={formData.minimumPercentage}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Instruction */}
                <div className="profile-input-area mb-4">
                  <label htmlFor="Instruction" className="profile-badge">Instruction*</label>
                  <textarea
                    name="instruction"
                    className="profile-input"
                    value={formData.instruction}
                    onChange={handleChange}
                    required
                  />
                </div>

                {/* Button */}
                <div className="d-flex justify-content-center mb-4">
                  <button className="profile-btn mt-2"><FaCheck /> SAVE</button>
                </div>
              </form>
            </div>
          </div>

          {/* Table */}
          <div className='col-xl-9 col-lg-8 col-md-7 col-12 my-2 h-100'>
            <div className='profile-card'>
              <div className='d-md-flex d-sm-flex justify-content-between mb-2'>
                <span className="profile-heading align-content-center">Online Exam List</span>
                <div className='profile-input-area ms-auto col-lg-3 border-0'>
                  <input
                    type='text'
                    name='search'
                    className='profile-input border-bottom rounded-0'
                    placeholder='Search...'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
                  />
                </div>
              </div>

              <div className='table-responsive'>
                <table className='w-100'>
                  <thead className='account-thead'>
                    <tr>
                      <th className='rounded-start-4'>S No</th>
                      <th>Title</th>
                      <th>Class</th>
                      <th>Subject</th>
                      <th>Exam Dates</th>
                      <th>Timing</th>
                      <th>Passing %</th>
                      <th>Added By</th>
                      <th className='rounded-end-4'>Activty</th>
                    </tr>
                  </thead>

                      {filteredExam.map((q, index) => (
                        <tr className='account-tr' key={q.id}>
                          <td>{index + 1}</td>
                          <td>{q.title}</td>
<td>{
  (() => {
    try {
      const parsed = JSON.parse(q.class_id);
      return parsed.className || '';
    } catch {
      return '';
    }
  })()
}</td>

                          <td>{q.sub_name}<br />({q.sub_type}) ({q.sub_code})</td>
                          <td>{q.start_date || '--'} - {q.end_date || '--'}</td>
                          <td>From {q.start_time || '--'}<br />To {q.end_time || '--'}</td>
                          <td>{q.min_percent || '--'}%</td>
                          <td>{q.addedby_name || '--'}<br />({q.designation})</td>
    <td>{userData.user_id == q.added_by || userData.role == 'SupAdmin' ? (
      <>
      <MdOutlineEdit onClick={() => handleShowView(q)} className='account-icon1 me-2' /> 
      <HiViewGrid onClick={() => handleShowReport(q)} className='account-icon2' /> 
              </>
    )
: '--'}
      </td>
                        </tr>
                      ))}

                </table>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>

{showView && (
    <>
        <section className='ins-dialog'>
          <div className='col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <button className='profile-btn2' onClick={() => setShowView(false)}>Go Back</button>


              <div className='table-responsive mt-4 bg-white rounded-top-4 px-3'>
                                    <p className='profile-heading my-3'>Exam Questions</p>

                <table className='w-100'>

                  <thead className='account-thead'>
                    <th className='rounded-start-4'>Select</th>
                    <th>Group</th>
                    <th>Class</th>
                    <th>Question</th>
                    <th>Type</th>
                    <th>Options</th>
                    <th className='rounded-end-4'>Correct Ans</th>
                  </thead>


<tbody>
  {questions.map((q, index) => {
    const isSelected = selectedQuestions.some(sq => sq.id === q.id);
    return (
      <tr className='account-tr' key={q.id}>
        <td className='fs-3'>
          <input
            type='checkbox'
            checked={isSelected}
            onChange={() => handleCheckboxToggle(q)}
          />
        </td>
        <td>{q.ques_group}</td>
        <td>{q.class_name}</td>
        <td>{q.ques || '--'}</td>
        <td>{q.ques_type || '--'}</td>
        <td className='text-nowrap'>
          {q.ques_type === 'MCQ' && q.options ? (
            typeof q.options === 'string' ? (
              JSON.parse(q.options).map((opt, idx) => (
                <div key={idx}>
                  {String.fromCharCode(65 + idx)}. {opt.text}
                </div>
              ))
            ) : (
              q.options.map((opt, idx) => (
                <div key={idx}>
                  {String.fromCharCode(65 + idx)}. {opt.text}
                </div>
              ))
            )
          ) : (
            '--'
          )}
        </td>
        <td>{q.correct_ans || '--'}</td>
      </tr>
    );
  })}
</tbody>

                  </table>

                  <div className='my-4'>
  <button
    className='profile-btn'
    onClick={submitSelectedQuestions}
    // disabled={selectedQuestions.length === 0}
  >
    Submit
  </button>
</div>
                  </div>


</div>
</section>
    </>
)}


</>
  )
}

export default OnlineExam
